module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab110-72abf2216558127c197e6eef88d4da48.jpg";